import { ITemplateDetailRepository } from 'orders/domain/repositories/ITemplateDetailRepository'
import { TemplateDetailEntity } from 'orders/domain/entities/templateDetail.entity'

export class GetTemplateDetailUseCase {
    constructor(private readonly repository: ITemplateDetailRepository) {}

    execute(templateId: number): Promise<TemplateDetailEntity> {
        return this.repository.getTemplateDetail(templateId)
    }
}
